import React from "react";
import { Container } from "../../components/container";

function AboutCreator() {
  return (
    <section
      className="bg-white"
      id="about-creator"
      aria-label="About the creator"
    >
      <Container>
        <div className="flex flex-col lg:flex-row gap-5">
          <div className="flex flex-col items-start">
            <h2 className="font-ppacma text-[56px] md:text-8xl leading-[90%] mt-6 lg:max-w-[760px] break-words">
              <span className="text-yellow">About the Creator of </span>{" "}
              <span className="text-black">League Life</span>
            </h2>

            <p className="text-black text-[18px] font-normal leading-[120%] tracking-[0px] lg:max-w-[462px] mt-6">
              League Life was founded by Nikki and JB Bickerstaff, who know
              firsthand the realities of life in the league. Constant moves, new
              cities, and shifting teams made it clear how hard it can be to
              find trusted guidance, reliable services, and genuine community.
              <br />
              <br />
              What began as a personal effort to make that life smoother for
              their own family and teams has grown into a platform built for
              every family who shares that experience. League Life reflects
              their belief that confidence, care, and connection should travel
              with you; no matter where the season leads.
            </p>
          </div>
          <div className="flex justify-center lg:justify-start">
            <img
              src="/about-creator/creator.png"
              alt="Nikki and JB Bickerstaff, founders of League Life"
              className="w-full h-auto lg:w-[691.08px]"
              loading="lazy"
              width="691"
              height="auto"
            />
          </div>
        </div>
      </Container>
    </section>
  );
}

export { AboutCreator };
